import { render } from "./VtoPageLoading.vue?vue&type=template&id=abfe1010"
import script from "./VtoPageLoading.vue?vue&type=script&lang=js"
export * from "./VtoPageLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__